(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-user-guide"]) return;
  try {
    
  document.querySelectorAll('[data-fs-guide]').forEach(function (root) {
    var search = root.querySelector('[data-guide-search]');
    var form = root.querySelector('[data-guide-search-form]');
    var cards = Array.from(root.querySelectorAll('[data-guide-card]'));
    var filters = Array.from(root.querySelectorAll('[data-guide-filter]'));
    var empty = root.querySelector('[data-guide-empty]');
    var activeSeries = 'all';
    function update() {
      var term = (search.value || '').trim().toLowerCase();
      var visible = 0;
      cards.forEach(function (card) {
        var matchesSeries = activeSeries === 'all' || card.dataset.series === activeSeries;
        var matchesSearch = !term || card.dataset.search.indexOf(term) !== -1;
        card.hidden = !(matchesSeries && matchesSearch);
        if (!card.hidden) visible += 1;
      });
      empty.hidden = visible !== 0;
    }
    form.addEventListener('submit', function (event) { event.preventDefault(); update(); });
    search.addEventListener('input', update);
    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        activeSeries = button.dataset.guideFilter;
        filters.forEach(function (item) { item.classList.toggle('is-active', item === button); });
        update();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
